import TrainingEnquiryCustomState from "@crescentParts/Store/Data/TrainingEnquiry/TrainingEnquiryState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState = {
    isTrainingEnquiry: false
};

const reducer = {
    "Custom/TrainingEnquiry/BeginTrainingEnquiry":(draft:Draft<TrainingEnquiryCustomState>)=>{
        draft.isTrainingEnquiry = true
    },
    "Custom/TrainingEnquiry/CompleteTrainingEnquiry":(draft:Draft<TrainingEnquiryCustomState>)=>{
        draft.isTrainingEnquiry = false
    },
}

export default createTypedReducerWithImmer(initialState, reducer);